'use client'

import { SkywardSite } from '@/types/skyward-types'
import { current } from 'immer'
import Link, { LinkProps } from 'next/link'
import { usePathname, useRouter } from 'next/navigation'
import React, { PropsWithChildren, useEffect, useState } from 'react'
import { twJoin, twMerge } from 'tailwind-merge'

type StyledLinkProps = {
  activeStyle?: string
  className?: string
} & LinkProps &
  PropsWithChildren
const StyledLink = ({ activeStyle, ...props }: StyledLinkProps) => {
  const currentRoute = usePathname()

  return (
    <Link {...props} className={twMerge(props.className, currentRoute == props.href && activeStyle)}>
      {props.children}
    </Link>
  )
}

const CommerceNavBar = () => {
  const style = 'px-4 py-2 rounded-md hover:bg-primary-light'
  const activeStyle = 'bg-primary-lighter hover:bg-primary-lighter'
  const { back } = useRouter()
  const handleBack = (e: any) => {
    e.preventDefault()
    back()
  }
  return (
    <div className="flex min-h-[52px] flex-row items-center space-x-4 bg-primary px-6 py-2 text-white">
      <>
        <StyledLink href={'#'} onClick={handleBack} className={style} activeStyle={activeStyle}>
          Back
        </StyledLink>
      </>
    </div>
  )
}

export default CommerceNavBar
